// By Categories
// Ordinary Drink, Cocktail, Milk / Float / Shake, Other/Unknown, Cocoa, Shot, Coffee / Tea, Homemade Liqueur, Punch / Party Drink, Beer, Soft Drink / Soda

//Random Cocktail
export const randomCtUrl = "https://thecocktaildb.com/api/json/v1/1/random.php";

// Search by name
export const nameUrl =
	"https://thecocktaildb.com/api/json/v1/1/search.php?s=margarita";
